import URLstateContext from "../../provider/CommonContext";
import MediaBanner from "../MediaCenter/MediaBanner/MediaBanner.js";
import React, { useEffect, useState, useContext } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { tabsClasses } from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import "../CommunicationHub/CommunicationHub.css";
import {
  GetPostMethodData,
  DecryptAESdata,
} from "../../provider/ServiceProvider";
import MediaIntraction from "./MediaIntraction/MediaIntraction.js";
import animation from "../../images/jm-animation.gif";
import { Modal } from "react-bootstrap";
import { AiFillCloseCircle } from "react-icons/ai";

function CommunicationHub() {
  const [FetchDatavdo, setFetchDatavdo] = useState("");
  const [value, setValue] = useState(1);
  const [pathname, setPathName] = useState("");
  const [data, setData] = useState("");
  const [show, setShow] = useState(false);
  const [loadingshow, setloadingshow] = useState(false);
  const {
    BaseURL,
    fontSize,
    changeFontSize,
    resetFontSize,
    changeFontSizeMinus,
  } = useContext(URLstateContext);

  useEffect(() => {
    const pathname = window.location.pathname;
    const lastSegment = pathname.slice(pathname.lastIndexOf("/") + 1);
    const CategoryIdUrlid = lastSegment;
    setPathName(CategoryIdUrlid);

    GetPostMethodData(BaseURL + "GetCommunicationHub", {
      IICategoryID: value,
      IISubCategoryID: 0,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setData(DecryptAESdata(data.data));
        setloadingshow(false);
      } else {
        setData(null);
        setloadingshow(false);
      }
    });
  }, [BaseURL, value]);

  const arrayOfTabsObj = [
    { name: "Media Interaction", id: 1 },
    // { name: "Product Outlook", id: 3 },
    { name: "Events", id: 4 },
  ];

  const navigate = useNavigate();

  const handleChange = (event, newValue) => {
    setValue(newValue);
    const selectedTab = arrayOfTabsObj.find((tab) => tab.id === newValue);
    navigate(`/Communication-Hub/${selectedTab.name.replace(/\s+/g, "-")}`);
  };

  useEffect(() => {
    var para = window.location.pathname.toLocaleLowerCase().split("/")[2];
    if (para === "media-interaction") setValue(1);
    // if (para === "product-outlook") setValue(3);
    if (para === "events") setValue(4);
  }, []);

  const clickyoutube = (event) => {
    setShow(true);
    GetPostMethodData(BaseURL + "GetVideoLink", {
      IVsrno: event,
    }).then((data) => {
      if (data.data != null && data.data.length > 0) {
        setFetchDatavdo(DecryptAESdata(data.data));
      }
    });
  };

  const handleClosePopup = () => {
    setShow(false);
  };

  return (
    <>
      <MediaBanner />
      <main id="main-content" tabIndex="-1">
      <section
        className="Nav-detail about-detail reachout Media-center"
        style={{ fontSize: `${fontSize}px` }}
      >
         <h1 className="sr-only">
            Media Interaction
         </h1>

        <Container>
          <Row>
            <Col>
              <ul className="navigator-arrow">
                <li>
                  <a href="/" aria-label="Home">
                    <i class="fa fa-home" aria-hidden="true"></i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                <li>
                  <a href="/Communication-Hub">
                    <i>Communication Hub</i>
                  </a>{" "}
                  <i class="fa fa-angle-right" aria-hidden="true"></i>
                </li>
                {window.location.pathname != "/Communication-Hub" ? (
                  <li>
                    {pathname
                      .replace(/([a-z])([A-Z])/g, "$1 $2")
                      .replace("-", " ")}
                  </li>
                ) : (
                  ""
                )}
              </ul>
            </Col>
          </Row>
        </Container>

        <Box>
          <TabContext value={value}>
            <Container className="tabs-nav tab-comm">
              <Row>
                <Col sm={12}>
                  <Box sx={{ width: "100%" }}>
                    <TabList
                      onChange={handleChange}
                      variant="scrollable"
                      sx={{
                        [`& .${tabsClasses.scrollButtons}`]: {
                          "&.Mui-disabled": { opacity: 0.3 },
                        },
                      }}
                      className="press-tabs"
                      scrollButtons="auto"
                    >
                      {arrayOfTabsObj.map((item) => (
                        <Tab
                          className={item.id == 3 ? "width185" : "width125"}
                          label={item.name}
                          value={item.id}
                        ></Tab>
                      ))}
                    </TabList>
                  </Box>
                </Col>
              </Row>
            </Container>

            {value == 1 ? (
              <TabPanel value={1}>
                <MediaIntraction />
              </TabPanel>
            ) : (
              <TabPanel value={value}>
                <section className="blog-sc global-blog-sc">
                  <Container>
                    <Row>
                      <Container>
                        <Col sm={12}>
                          <Row>
                            <div className="fund-container">
                              {data === null ? (
                                <h5 className="errormsgComNew" role="alert">
                                  No Data Available !!!
                                </h5>
                              ) : (
                                ""
                              )}
                              {data &&
                                data.map(
                                  ({
                                    Title,
                                    ThumbnailImage,
                                    CommunicationID,
                                  }) => (
                                    <div className="fund-inner zoom">
                                      <h3>{Title}</h3>
                                      <span
                                        onClick={(event) =>
                                          clickyoutube(CommunicationID)
                                        }
                                      >
                                        <img
                                          src={ThumbnailImage}
                                          className="img-fluid" alt="Thumbnail_image"
                                        ></img>
                                      </span>
                                    </div>
                                  )
                                )}
                              {loadingshow ? (
                                <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">
                                  <img src={animation} alt="" aria-hidden="true" />
                                  <div className="model_popup">
                                    Please Wait...
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                              {FetchDatavdo &&
                                FetchDatavdo.map(
                                  ({ Title, LinkLocation }, index) => (
                                    <Modal
                                      show={show}
                                      className="modal modal-teams"
                                      key={index}
                                    >
                                      <Modal.Body id="modal_info">
                                        <div className="btnDiv">
                                          <div
                                            className=""
                                            onClick={handleClosePopup}
                                          >
                                            <AiFillCloseCircle className="btncl" />
                                          </div>
                                        </div>
                                        <div className="youtubepopup">
                                          <p>{Title}</p>
                                          <div>
                                            <iframe
                                              className="iframe-vdo"
                                              src={LinkLocation}
                                              title="YouTube video player"
                                              frameBorder="0"
                                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                              allowFullScreen
                                            ></iframe>
                                          </div>
                                        </div>
                                      </Modal.Body>
                                    </Modal>
                                  )
                                )}
                            </div>
                          </Row>
                        </Col>
                      </Container>
                    </Row>
                  </Container>
                </section>
              </TabPanel>
            )}
          </TabContext>
        </Box>
      </section>

      </main>
    </>
  );
}

export default CommunicationHub;
